import { css } from '@emotion/react';
import { bpoints } from '../../Utils';

const whatsappButtonCSS = () => css`
    position: fixed;
    bottom: 24px;
    right: 24px;
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 50;

    /* Contenedor del botón y mensaje */
    .button-container {
        display: flex;
        align-items: center;
    }

    /* Estilos del botón de WhatsApp con animación de rebote */
    .whatsapp-button {
        display: flex;
        align-items: center;
        justify-content: center;
         background-color: #22ec9a;
        color: white;
        border: none;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        cursor: pointer;
        font-size: 16px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        animation: bounce 2s infinite;
    }

    .whatsapp-button:hover {
        background-color: #1ebe5b;
        transform: scale(1.1);
        box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
    }

    .whatsapp-button:active {
        transform: scale(0.95);
        box-shadow: 0 3px 7px rgba(0, 0, 0, 0.2);
    }

    .whatsapp-button svg {
        width: 32px;
        height: 32px;
        fill: currentColor;
    }

    /* Estilos del mensaje emergente con animación de aparición y desaparición */
    .whatsapp-message {
        background-color: #22ec9a;
        color: #22507f;
        padding: 6px 12px;
        border-radius: 5px;
        font-size: 14px;
        animation: fadeInOut 5s infinite;
        margin-right: 10px;
    }

    @media (max-width: ${bpoints.mobile.w}px) {
        .whatsapp-button {
            width: 50px;
            height: 50px;
        }

        .whatsapp-button svg {
            width: 22px;
            height: 22px;
        }

        .whatsapp-message {
            font-size: 12px;
        }
    }

    /* Animación de rebote del botón */
    @keyframes bounce {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-8px);
        }
    }

    /* Animación de aparición y desaparición del mensaje */
    @keyframes fadeInOut {
        0%, 100% {
            opacity: 0;
        }
        10%, 90% {
            opacity: 1;
        }
    }
`;

export default whatsappButtonCSS;
